import React from "react";
import CollapseBar from "./CollapseBar";


function newLinkHandler() {
 
  }

  function moveTopHandler() {

  }


function CollapseBarDisplay() {

return (  
	<div>
	<hr />
<CollapseBar
        // need id
        id={"cb1"}
        // title for the collapse bar
        // can be very long
        title={"titles goes here, long long long long long long long long"}
        // show/hide link, title,
        // and onclick action
        showNewLink={true}
        titleNewLink={"Add Meeting"}
        onClickNewLink={newLinkHandler}
        iconNewLink={"newMeeting"}
        // move to top link, title,
        // and onclick action
        showMoveTop={true}
        titleMoveTop={"Top"}
        onClickMoveTop={moveTopHandler}
        // collapse expand button
        // turn it on/off
        // target div ID
        showCollapseBT={true}
        targetDivID={"theDiv2Hide1"}
        //should it be open or close on load
        // true/false
        initStateExpand={false}
      />
      <div id="theDiv2Hide1">
        this is the div 1 need to expand collapse.
        <br />
        <hr />
        this is the div 1 need to expand collapse.
        <br />
        <hr />
        this is the div 1 need to expand collapse.
        <br />
        <hr />
      </div>
      <CollapseBar
        // need id
        id={"cb2"}
        // title for the collapse bar
        // can be very long
        title={" second titles goes here"}
        // show/hide link, title, icon(newMeeting or newPerson)
        // and onclick action
        showNewLink={true}
        titleNewLink={"Add User"}
        iconNewLink={"newPerson"}
        onClickNewLink={newLinkHandler}
        // move to top link, title,
        // and onclick action
        showMoveTop={true}
        titleMoveTop={"Top"}
        onClickMoveTop={moveTopHandler}
        // collapse expand button
        // turn it on/off
        // target div ID
        showCollapseBT={true}
        targetDivID={"theDiv2Hide2"}
        //should it be open or close on load
        // true/false
        initStateExpand={true}
      />
      <div id="theDiv2Hide2">
        this is the div 2 need to expand collapse.
        <br />
        <hr />
        this is the div 2 need to expand collapse.
        <br />
        <hr />
        this is the div 2 need to expand collapse.
        <br />
        <hr />
      </div>

      <CollapseBar
        // need id
        id={"cb3"}
        // title for the collapse bar
        // can be very long
        title={"third titles goes here, no link on right."}
        // show/hide link, title, icon(newMeeting or newPerson)
        // and onclick action
        showNewLink={false}
        // move to top link, title,
        // and onclick action
        showMoveTop={false}
        // collapse expand button
        // turn it on/off
        // target div ID
        showCollapseBT={false}
        //should it be open or close on load
        // true/false
        initStateExpand={true}
      />
      <div id="theDiv2Hide3">
        this is the div 3 need to expand collapse.
        <br />
        <hr />
        this is the div 3 need to expand collapse.
        <br />
        <hr />
        this is the div 3 need to expand collapse.
        <br />
        <hr />
      </div>
</div>
  );

}
export default CollapseBarDisplay;


